import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/workspaces/$workspaceId/settings/')({
  component: () => {
    const { workspaceId } = Route.useParams()
    return <Navigate to="/workspaces/$workspaceId/settings/details" params={{ workspaceId }} replace />
  },
})
